var _circle, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_770_6",
    "data-name": "Component 770 \\u2013 6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1641",
    "data-name": "Ellipse 1641",
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#f1f1ed"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_769_10",
    "data-name": "Component 769 \\u2013 10",
    transform: "translate(14 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50629",
    "data-name": "Path 50629",
    d: "M235.312-790.385l1.577,1.577H215.379a3.282,3.282,0,0,1-2.421-.957,3.282,3.282,0,0,1-.957-2.421v-32.435a3.281,3.281,0,0,1,.957-2.421,3.281,3.281,0,0,1,2.421-.957H232.5l9.685,11.6v24.213a1.492,1.492,0,0,1-.225.732,3.469,3.469,0,0,1-.563.732l-10.586-10.586a6.873,6.873,0,0,1-1.833.957,6.118,6.118,0,0,1-1.883.282,5.855,5.855,0,0,1-4.295-1.787,5.855,5.855,0,0,1-1.787-4.295,5.857,5.857,0,0,1,1.787-4.3,5.856,5.856,0,0,1,4.295-1.786,5.858,5.858,0,0,1,4.3,1.786,5.858,5.858,0,0,1,1.786,4.3,5.961,5.961,0,0,1-.31,2,6.7,6.7,0,0,1-.929,1.718l8.672,8.784v-22.186l-8.9-10.586h-16.33a1.722,1.722,0,0,0-1.239.563,1.722,1.722,0,0,0-.563,1.239v32.435a1.722,1.722,0,0,0,.563,1.239,1.722,1.722,0,0,0,1.239.563Zm-8.221-11.262a4.338,4.338,0,0,0,3.182-1.323,4.338,4.338,0,0,0,1.323-3.182,4.338,4.338,0,0,0-1.323-3.182,4.338,4.338,0,0,0-3.182-1.323,4.338,4.338,0,0,0-3.182,1.323,4.338,4.338,0,0,0-1.323,3.182,4.338,4.338,0,0,0,1.323,3.182A4.338,4.338,0,0,0,227.091-801.647ZM227.091-807.616ZM227.091-807.616Z",
    transform: "translate(-200.447 834.602)",
    fill: "#707070"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_15928",
    "data-name": "Rectangle 15928",
    width: 52,
    height: 52,
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/NoData.16ed775a877a657ad66551ee12b8b392.svg";
export { ForwardRef as ReactComponent };